"use client"

import type React from "react"
import { useState,useEffect } from "react"
import { Eye, EyeOff } from "lucide-react";
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import GoogleLoginButton from "./GoogleLoginButton";
import { useTheme } from '../../../redux/hooks/useTheme';
import { motion, Variants } from 'motion/react';
import {Link, useNavigate } from "react-router-dom";
import Logo from "../Dashboard/SubComponents/Logo";

import ReCAPTCHAComponent from "../../utils/ReCAPTCHA"
interface LoginFormProps {
  onSubmit?: (email: string, password: string) => void
  onForgotPassword?: () => void
  onSignupClick?: () => void
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit,  onForgotPassword, onSignupClick }) => {
  const location = useLocation();
  const [email, setEmail] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { theme } = useTheme();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Only validate if it's a form submission
    const isFormSubmit = (e.nativeEvent as SubmitEvent).submitter?.getAttribute('type') === 'submit';
    
    if (isFormSubmit) {
      // Show validation messages only for form submit
      if (!email && !password) {
        toast.error("Please enter email and password");
        return;
      }
      if (!email) {
        toast.error("Please enter email");
        return;
      }
      if (!password) {
        toast.error("Please enter password");
        return;
      }
    
      // If we have both email and password, proceed with login
      if (onSubmit) {
        setIsLoading(true);
        try {
          await onSubmit(email, password);
        } finally {
          setIsLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setEmail(emailParam);
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location]);

  return (
    <div  style={{
      background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
      backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
    }}
    className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
    <ReCAPTCHAComponent/>
    <div className="flex flex-col justify-center items-center gap-[40px]">
    <motion.div
                className="flex mt-[-38px] items-center w-[132px] sm:w-auto logo-mob"
              >
                <Link to="/">
                {/* <img
                  src={theme.heroLogo} // Use src instead of background
                  className="h-10 mr-2 md:p-0"
                  alt="Advance To Builder"
                />   */}
                <Logo />
                </Link>
              </motion.div>
      <div style={{}} className="flex relative">
      <div className="sign-up-upr">        
     <div
        className="w-full max-w-[480px] rounded-[20px] bg-white p-[20px] sm:p-[32px] md:p-[40px] signup-p"
        style={{ width: '100%' }}
      >
        <div className="">
          {/* Header */}
          <div className="text-center">
            <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[22px] font-sora">Welcome back!</h2>
            <p style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mt-[10px] mb-[24px] font-inter">Log in and continue crafting powerful tools.</p>
          </div>

          {/* Form */}
          <form className="flex flex-col gap-[18px]" onSubmit={handleSubmit} noValidate>
            {/* Email Input */}
            <div className="relative">
              <div className="absolute inset-y-0 p-[14px] flex items-center spborder-r">
               
                <span style={{color:theme.seIcon}}>
                  
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7499 15.375H5.24994C2.99994 15.375 1.49994 14.25 1.49994 11.625V6.375C1.49994 3.75 2.99994 2.625 5.24994 2.625H12.7499C14.9999 2.625 16.4999 3.75 16.4999 6.375V11.625C16.4999 14.25 14.9999 15.375 12.7499 15.375Z" stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.7501 6.75L10.4026 8.625C9.63006 9.24 8.36256 9.24 7.59006 8.625L5.25006 6.75"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                </span>
              </div>
              <input
                type="email"
                placeholder="Enter email"
                className="w-full sp-border signout-h  rounded-[12px] border py-[14px] pl-[55px] pr-4 focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password Input */}
            <div className="relative">
              <div className="absolute inset-y-0 p-[15px] flex items-center spborder-r">
                <span style={{color:theme.seIcon}}>
               
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                </span>
              </div>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter password"
                className="w-full rounded-lg border sp-border signout-h rounded-[12px] py-[14px] pl-[55px] pr-10 focus:outline-none"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <span style={{color:theme.seIcon}}>
                  <Eye className="h-5 w-5 text-gray-400" />
                  </span>
                 
                ) : (
                  <span style={{color:theme.seIcon}}>
                     <EyeOff className="h-5 w-5 text-gray-400" />
                  </span>
                )}
              </button>
            </div>

            {/* Forgot Password Link */}
            <div className="flex justify-end">
              <button style={{fontWeight:500 }}  type="button" className="text-[12px] mt-[-8px] hover:underline hover:decoration-[#ff3ab6]" onClick={onForgotPassword}>
                <span className="gradient-text font-inter">Forgot Password?</span>
              </button>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              disabled={isLoading}
              style={{fontWeight:400 }}  
              className="w-full sign-upbt rounded-[12px] mt-[24px] font-inter text-[12px] py-[14px] focus:outline-none disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Logging in...
                </span>
              ) : (
                'Log In'
              )}
            </button>

            {/* Divider */}
            <div className="relative flex items-center mt-[-4px] mb-[-4px]">
              <div className="flex-grow border-t sp-border"></div>
              <span style={{ color:theme.seIcon}} className="mx-4 font-inter flex-shrink ">Or</span>
              <div className="flex-grow border-t sp-border"></div>
            </div>

            {/* Google Button - Now in its own div outside form validation */}
            <div onClick={(e) => e.stopPropagation()}>
              <GoogleLoginButton />
            </div>

          </form>

          {/* Signup Link */}
          <div style={{fontWeight:400, textAlign:'center' }} className="s-suggestion font-inter mt-[14px] text-[12px]">
            Don't have an account?{" "}
            <button className="gradient-text font-inter text-[12px]" onClick={onSignupClick}>
             <span className="gradient-text  hover:underline hover:decoration-[#ff3ab6]"> Sign up</span>
            </button>
          </div>
        </div>
      </div>
      </div>
      </div>
    </div>
    </div>
  )
}

export default LoginForm

